import React, { useState } from "react";
import { Button, Grid, TextField } from "@mui/material";


const AcquiredCertificationsForm = ({ dispatch }) => {
  const [certName, setCertName] = useState({
    value: "",
    hasError: true,
    showError: false,
    errorText: "Certificate name is required",
  });

  const [issuerName, setIssuerName] = useState({
    value: "",
    hasError: true,
    showError: false,
    errorText: "Issuer name is required",
  });

  function handleCertFieldChange(event, setState) {
    const { value } = event.target;
    
    if (value !== " ") {
      if (value.length > 0) {
        setState({
          value: value,
          hasError: false,
          showError: false,
          errorText: "",
        });
      } else if (value === "") {
        setState({
          value: value,
          hasError: true,
          showError: false,
          errorText: "This field cannot be empty",
        });
      }
    }
  }

  function handleAddCert() {
    if (certName.hasError || issuerName.hasError) {
      if (certName.hasError) {
        setCertName({ ...certName, showError: true });
      }
      if (issuerName.hasError) {
        setIssuerName({ ...issuerName, showError: true });
      }
    } else {
      const newCert = {
        certificationName: certName.value,
        issuedBy: issuerName.value,
      };

      dispatch({type: "stagedCertificate", body: newCert});

      // state resets
      setCertName({
        value: "",
        hasError: true,
        showError: false,
        errorText: "Certificate name is required",
      });
      setIssuerName({
        value: "",
        hasError: true,
        showError: false,
        errorText: "Issuer name is required",
      });
    }
  }

  const acquiredCertificationsFormMarkup = [
    {
      type: "textField",
      label: "Certification Name*",
      value: certName.value,
      onChange: (event) => handleCertFieldChange(event, setCertName),
      hasError: certName.showError && certName.hasError,
      errorText: certName.showError && certName.errorText,
    },
    {
      type: "textField",
      label: "Name of Issuer*",
      value: issuerName.value,
      onChange: (event) =>
        handleCertFieldChange(event, setIssuerName),
      hasError: issuerName.showError && issuerName.hasError,
      errorText: issuerName.showError && issuerName.errorText,
    },
  ];

  return (
    <Grid
      item
      xs
      container
      direction={"column"}
      gap={"1rem"}
      sx={{
        border: "1px solid lightgrey",
        borderRadius: "7px",
        padding: "2rem",
      }}
    >
      <h4>Acquired Certifications Form </h4>
      <Grid item xs container direction={"row"} gap={"2rem"}>
        {acquiredCertificationsFormMarkup.map((field) => (
          <Grid
            item
            xs
            key={field.label}
            style={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            {field.label}
            <TextField
              value={field.value}
              onChange={field.onChange}
              error={field.hasError}
              helperText={field.errorText}
              size="small"
            />
          </Grid>
        ))}
        <Grid
          item
          xs
          style={{
            flexGrow: 0,
            marginTop: "1.5rem",
          }}
        >
          <Button variant="outlined" onClick={handleAddCert}>
            Add
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default AcquiredCertificationsForm;